import { z } from 'zod';

export const NotificationsDevicesScalarFieldEnumSchema = z.enum(['id','city_id','device_type','platform_details','platform_uid','app_version','registered_at','heartbeat_at','user_id','token_id']);

export default NotificationsDevicesScalarFieldEnumSchema;
